import { t } from "../i18n";
import { ErrorApi } from "./cliente";

/**
 * Qué decir cuando una acción falla. Un 409 trae en su mensaje la regla de negocio que no se cumplió,
 * escrita por la API para mostrarse tal cual (por ejemplo «Ese correo ya tiene usuario»).
 */
export function mensajeDeAccion(e: unknown): string {
  if (e instanceof ErrorApi && e.estado === 409) return e.message;
  if (e instanceof ErrorApi && e.estado === 403) return t.general.errorSinPermiso;
  return t.general.errorAccion;
}
